import { FC } from 'react'
import { Text, TextProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type ButtonProps = TextProps & UnistylesVariants<typeof stylesheet>

const Button: FC<ButtonProps> = ({ children, size = 'medium', style, ...props }) => {
    const { styles } = useStyles(stylesheet, { size })

    return (
        <Text {...props} style={[styles.button, style]}>
            {children}
        </Text>
    )
}

const buttonBigFontSize = 14
const buttonMediumFontSize = 12
const buttonSmallFontSize = 10
const buttonTinyFontSize = 8

const letterSpacingMultiplier = 0.05

const stylesheet = createStyleSheet((theme) => ({
    button: {
        fontFamily: theme.fonts.bold,
        variants: {
            size: {
                big: {
                    fontSize: buttonBigFontSize,
                    letterSpacing: buttonBigFontSize * letterSpacingMultiplier,
                },
                medium: {
                    fontSize: buttonMediumFontSize,
                    letterSpacing: buttonMediumFontSize * letterSpacingMultiplier,
                },
                small: {
                    fontSize: buttonSmallFontSize,
                    letterSpacing: buttonSmallFontSize * letterSpacingMultiplier,
                },
                tiny: {
                    fontSize: buttonTinyFontSize,
                    letterSpacing: buttonTinyFontSize * letterSpacingMultiplier,
                },
            },
        },
    },
}))

export default Button
